import React from "react";
import { Flex, Spin } from "antd";

export const Spinner: React.FC = () => (
  <Flex align="center" gap="middle">
    <Spin size="small" />
  </Flex>
);

// You can use any loader component/library you prefer

export const Loader: React.FC<{ height?: string | number }> = ({
  height = "149.25vh", //100vh
}) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height,
      }}
    >
      <Spin size="large" />
    </div>
  );
};

export default Loader;
